<template>
  <div>
    <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!['admin', 'manager', 'customer'].includes(location.slug)" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{ __('Delete') }}</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

  <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    location: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.location.name,
      }),
    }
    //   console.log(this.access)
  },
  methods: {
    update() {
      this.form.put(this.route('locations.update', this.location.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this location?')) {
        this.$inertia.delete(this.route('locations.destroy', this.location.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this location?')) {
        this.$inertia.put(this.route('locations.restore', this.location.id))
      }
    },
  },
}
</script>
